import React, { useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import TotalCase from "../../../images/totalCase.svg";
import TotalOrange from "../../../images/total_orange.svg";
import RedCase from "../../../images/red_case.svg";
import TotalCart from "../../../images/total_cart.svg";
import TotalTrey from "../../../images/total_tray.svg";
import TotalKnifes from "../../../images/total_knifes.svg";
import TotalBowls from "../../../images/total_bowl.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import WashingModal from "./WashingModal";
import EmployeeHistory from "./EmployeeHistory";
import {
  useGetProcessingEveningEmployeeQuery,
  useGetProcessingMorningEmployeeQuery,
  useGetProcessingWashingSummaryQuery,
} from "./processingWashingApi.js";
import { useGetProcessingSummaryQuery } from "../dashboard/processingApi.js";
import { EditSvg } from "../../../svgFiles/EditSvg.js";
import useTranslator from "../../../hooks/useTranslator.js";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils.jsx";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants.js";
const ProcessingWashing = () => {
  const [page, setPage] = useState(1);
  const [addEmployee, setAddEmployee] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [empcolumns, setEmpColumns] = useState(null);  
  const currentDate = getCurrentDate('YYYY-MM-DD');
  const [date, setDate] = useState(currentDate);
  const [history, setHistory] = useState(false);
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("washing");
  const { _t } = useTranslator();

  const { data: morningData, isLoading: isMorningLoading, isFetching: isMorningFetching } = useGetProcessingMorningEmployeeQuery({
    page,
    "filter[date]": date,
  });
  const { data: morningDataHistory } = useGetProcessingMorningEmployeeQuery({
    page,
  });
  const { data: eveningData, isLoading: isEveningLoading, isFetching: isEveningFetching } = useGetProcessingEveningEmployeeQuery({
    page,
    "filter[date]": date,
  });
  const { data: eveningDataHistory } = useGetProcessingEveningEmployeeQuery({
    page,
  });
  const { data: summaryData } = useGetProcessingSummaryQuery({ tab, date });

  const handleHistory = () => {
    setHistory(true);
    setModalMode("morning");
    setEmpColumns(columns);
    setData(morningDataHistory);
  };
  const handleAddData = () => {
    setAddEmployee(true);
    setModalMode("addMorning");
    setSelectedEmployee(null);
    setShowModal(true);
  };
  const handleEveningHistory = () => {
    setHistory(true);
    setModalMode("evening");
    setEmpColumns(eveningcolumns);
    setData(eveningDataHistory);
  };
  const handleEveningAddData = () => {
    setAddEmployee(true);
    setModalMode("addEvening");
    setSelectedEmployee(null);
    setShowModal(true);
  };
  const handleEditMorning = (data) => {
    setAddEmployee(true);
    setModalMode("editMorning");
    setSelectedEmployee(data);
    setShowModal(true);
  };
  const handleEditEvening = (data) => {
    setAddEmployee(true);
    setModalMode("editEvening");
    setSelectedEmployee(data);
    setShowModal(true);
  };
  const listItems = [
    {
      label: _t("total_cases_label", "Total Cases"),
      value: summaryData?.data.total_cases,
      icon: TotalCase,
    },
    {
      label: _t("orange_cases_label", "Orange Cases"),
      value: summaryData?.data.orange_cases,
      icon: TotalOrange,
    },
    {
      label: _t("red_cases_label", "Red Cases"),
      value: summaryData?.data.red_cases,
      icon: RedCase,
    },
    {
      label: _t("yellow_cases_label", "Yellow Cases"),
      value: summaryData?.data.yellow_cases,
      icon: TotalCase,
    },
    {
      label: _t("total_carts_label", "Total Carts"),
      value: summaryData?.data.total_carts,
      icon: TotalCart,
    },
    {
      label: _t("total_treys_label", "Total Treys"),
      value: summaryData?.data.total_treys,
      icon: TotalTrey,
    },
    {
      label: _t("total_knifes_label", "Total Knifes"),
      value: summaryData?.data.total_knifes,
      icon: TotalKnifes,
    },
    {
      label: _t("total_bowls_label", "Total Bowls"),
      value: summaryData?.data.total_bowls,
      icon: TotalBowls,
    },
  ];
  const columns = [
    {
      label: _t("date_label", "Date"),
      accessor: "date",
    },
    {
      label: _t("total_employee_label", "Total Employee"),
      accessor: "emp_total",
    },
    {
      label: _t("orange_cases_label", "Orange Cases"),
      accessor: "orange_cases",
    },
    {
      label: _t("red_cases_label", "Red Cases"),
      accessor: "red_cases",
    },
    {
      label: _t("yellow_cases_label", "Yellow Cases"),
      accessor: "yellow_cases",
    },
  ];
  const eveningcolumns = [
    {
      label: _t("date_label", "Date"),
      accessor: "date",
    },
    {
      label: _t("total_employee_label", "Total Employee"),
      accessor: "emp_total",
    },
    {
      label: _t("carts_label", "Carts"),
      accessor: "carts",
    },
    {
      label: _t("trey_label", "Trey"),
      accessor: "treys",
    },
    {
      label: _t("knifes_label", "Knifes"),
      accessor: "knifes",
    },
    {
      label: _t("bowls_label", "Bowls"),
      accessor: "bowls",
    },
  ];


  return !history ? (
    <div>
      {addEmployee && (
        <WashingModal
          show={showModal}
          setShow={setAddEmployee}
          mode={modalMode}
          employee={selectedEmployee}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("washing_overview", "Washing Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <Datatable
        title={_t("morning_shift_employee", "Morning Shift Employee")}
        columns={columns}
        tableData={
          morningData?.data
            ? { ...morningData.data, data: morningData.data.data.slice(0, 1) }
            : { data: [] }
        }
        page={page}
        buttons={[
          {
            label: _t("history", "History"),
            onClick: handleHistory,
            className: "borderRedBtn",
          },
          morningData?.data?.data?.length > 0
            ? {
              label: _t("edit_data", "Edit Data"),
              onClick: () => handleEditMorning(morningData.data.data[0]),
              icon: <EditSvg color="#fff" />,
            }
            : {
              label: _t("add_data", "Add Data"),
              onClick: handleAddData,
              icon: PlusSvg,
            },
        ]}
        showCount={false}
        showPegination={false}
        isLoading={isMorningLoading || isMorningFetching}
      />
      <Datatable
        title={_t("evening_shift_employee", "Evening Shift Employee")}
        columns={eveningcolumns}
        tableData={
          eveningData?.data
            ? { ...eveningData.data, data: eveningData.data.data.slice(0, 1) }
            : { data: [] }
        }
        page={page}
        buttons={[
          {
            label: _t("history", "History"),
            onClick: handleEveningHistory,
            className: "borderRedBtn",
          },
          eveningData?.data?.data?.length > 0
            ? {
              label: _t("edit_data", "Edit Data"),
              onClick: () => handleEditEvening(eveningData.data.data[0]),
              icon: <EditSvg color="#fff" />,
            }
            : {
              label: _t("add_data", "Add Data"),
              onClick: handleEveningAddData,
              icon: PlusSvg,
            },
        ]}
        showCount={false}
        showPegination={false}
        isLoading={isEveningLoading || isEveningFetching}
      />
    </div>
  ) : (
    <div>
      <EmployeeHistory
        setShow={setHistory}
        modalMode={modalMode}
        columns={empcolumns}
        tableData={data}
      />
    </div>
  );
};

export default ProcessingWashing;
